import { Common } from "./Common";

export class Designation extends Common {

    location_name: string;
    location_type: string;
    name: string;
    emp_id: string;
    emp_json: any;
    parent_id: string;

    event_id: string;
    vote_for: number;
    vote_oppose: number;
    vote_total: number;
}